import { animate } from "popmotion"

const accordions = document.querySelectorAll(".single-accordion")

accordions.forEach((accordion) => {
    const triggers = accordion.querySelectorAll(".open-trigger")

    triggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
            toggleAccordion(accordion)

            Array.from(accordions)
                .filter((a) => a !== accordion)
                .forEach((acc) => {
                    closeAccordion(acc)
                })
        })
    })
})

function closeAccordion(accordion) {
    const target = accordion.querySelector(".open-target")
    const whenClosedEl = accordion.querySelector(".when-closed")
    const whenOpenedEl = accordion.querySelector(".when-opened")

    animate({
        from: parseFloat(target.style.height.replace("px", "")),
        to: 0,
        onUpdate: (v) => {
            target.style.height = v + "px"
        },
    })
    whenOpenedEl.style.display = "none"
    whenClosedEl.style.display = "block"
}

function toggleAccordion(accordion) {
    const target = accordion.querySelector(".open-target")
    const whenClosedEl = accordion.querySelector(".when-closed")
    const whenOpenedEl = accordion.querySelector(".when-opened")

    if (target.style.height !== "0px") {
        animate({
            from: parseFloat(target.style.height.replace("px", "")),
            to: 0,
            onUpdate: (v) => {
                target.style.height = v + "px"
            },
        })
        whenOpenedEl.style.display = "none"
        whenClosedEl.style.display = "block"
    } else {
        animate({
            from: parseFloat(target.style.height.replace("px", "")),
            to: target.scrollHeight,
            onUpdate: (v) => {
                target.style.height = v + "px"
            },
        })
        whenOpenedEl.style.display = "block"
        whenClosedEl.style.display = "none"
    }
}
